import React, { Component } from 'react';
import { connect } from 'react-redux';
import Login from '../components/Login';
import CodeUnlock from '../components/CodeUnlock';
import Header from '../components/Header';
import Footer from '../components/Footer';

/**
 * CodeUnlockPage
 *
 * Routes:
 *   /unlock               — manual code entry
 *   /unlock/:code         — auto-submit the code in the URL path
 *   /unlock?code=XXX      — auto-submit the code in the query string
 *   (and /:brand/:act variants of all three)
 *
 * urlCode priority: route param (:code) > query string (?code=)
 */
class CodeUnlockPage extends Component {
    constructor(props) {
        super(props);
        this.loginChild = null;
    }

    handleGoToCards = () => {
        const { history, location } = this.props;
        // Strip both /unlock and /unlock/:code from the end of the path
        const basePath = location.pathname.replace(/\/unlock(\/[^\/]+)?$/, '');
        history.push(`${basePath}/cards`);
    };

    handleShowLogin = () => {
        if (this.loginChild) {
            this.loginChild.toInitial();
            this.loginChild.toLogin();
        }
    };

    handleShowRegister = () => {
        if (this.loginChild) {
            this.loginChild.toInitial();
            this.loginChild.toRegister();
        }
    };

    render() {
        const { location, match } = this.props;
        // Route param (:code) takes priority over query string (?code=)
        const routeCode = match.params.code || undefined;
        const queryCode = new URLSearchParams(location.search).get('code') || undefined;
        const urlCode   = routeCode || queryCode;

        return (
            <div className="unlock-page desc-font">
                <Header />

                <div className="page-inner">
                    <div className="panels-cont">
                        {/*
                          * Login renders the fixed top welcome panel when
                          * logged in, or the login/register form when not.
                          * Same onRef pattern as App.js.
                          */}
                        <Login onRef={ref => (this.loginChild = ref)} />

                        <CodeUnlock
                            urlCode={urlCode}
                            onGoToCards={this.handleGoToCards}
                            onShowLogin={this.handleShowLogin}
                            onShowRegister={this.handleShowRegister}
                        />
                    </div>
                </div>

                <Footer />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    ...ownProps,
    auth: state.default.auth,
});

export default connect(mapStateToProps)(CodeUnlockPage);
